module.exports = __webpack_public_path__ + "static/IMG_0256-92c330948a7fa0524ab969ce735a770d.jpg";